var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnemoclinograph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_3742)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_173_3742)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_173_3742",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09912 4H7.09912V8.0569C5.93393 8.19418 5.09912 8.56459 5.09912 9V12.5078C4.47676 12.7722 4.09912 13.1196 4.09912 13.5C4.09912 14.3284 5.88998 15 8.09912 15C10.3083 15 12.0991 14.3284 12.0991 13.5C12.0991 13.1196 11.7215 12.7722 11.0991 12.5078V9C11.0991 8.56459 10.2643 8.19418 9.09912 8.0569V4Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09912 4H7.09912V8.0569C5.93393 8.19418 5.09912 8.56459 5.09912 9V12.5078C4.47676 12.7722 4.09912 13.1196 4.09912 13.5C4.09912 14.3284 5.88998 15 8.09912 15C10.3083 15 12.0991 14.3284 12.0991 13.5C12.0991 13.1196 11.7215 12.7722 11.0991 12.5078V9C11.0991 8.56459 10.2643 8.19418 9.09912 8.0569V4Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09912 4V3.4H6.49912V4H7.09912ZM9.09912 4H9.69912V3.4H9.09912V4ZM7.09912 8.0569L7.16933 8.65278L7.69912 8.59036V8.0569H7.09912ZM5.09912 12.5078L5.33375 13.06L5.69912 12.9048V12.5078H5.09912ZM11.0991 12.5078H10.4991V12.9048L10.8645 13.06L11.0991 12.5078ZM9.09912 8.0569H8.49912V8.59036L9.02892 8.65278L9.09912 8.0569ZM7.09912 4.6H9.09912V3.4H7.09912V4.6ZM7.69912 8.0569V4H6.49912V8.0569H7.69912ZM5.69912 9C5.69912 9.09711 5.64993 9.13502 5.67557 9.10895C5.70353 9.08052 5.77466 9.02581 5.91442 8.96105C6.19156 8.83264 6.6239 8.71704 7.16933 8.65278L7.02892 7.46102C6.40915 7.53404 5.84149 7.67229 5.40993 7.87225C5.19534 7.97168 4.98494 8.09979 4.81996 8.26757C4.65266 8.4377 4.49912 8.68518 4.49912 9H5.69912ZM5.69912 12.5078V9H4.49912V12.5078H5.69912ZM4.69912 13.5C4.69912 13.5233 4.68498 13.4869 4.78401 13.3906C4.88473 13.2926 5.06245 13.1753 5.33375 13.06L4.8645 11.9556C4.51343 12.1048 4.19115 12.2933 3.94746 12.5302C3.70208 12.7688 3.49912 13.0962 3.49912 13.5H4.69912ZM8.09912 14.4C7.04745 14.4 6.12207 14.2391 5.48137 13.9989C5.1588 13.8779 4.93944 13.7483 4.8115 13.6349C4.68287 13.5209 4.69912 13.4739 4.69912 13.5H3.49912C3.49912 13.9403 3.73923 14.288 4.01542 14.5328C4.2923 14.7783 4.65873 14.972 5.06002 15.1225C5.86703 15.4251 6.94165 15.6 8.09912 15.6V14.4ZM11.4991 13.5C11.4991 13.4739 11.5154 13.5209 11.3867 13.6349C11.2588 13.7483 11.0394 13.8779 10.7169 13.9989C10.0762 14.2391 9.15079 14.4 8.09912 14.4V15.6C9.25659 15.6 10.3312 15.4251 11.1382 15.1225C11.5395 14.972 11.9059 14.7783 12.1828 14.5328C12.459 14.288 12.6991 13.9403 12.6991 13.5H11.4991ZM10.8645 13.06C11.1358 13.1753 11.3135 13.2926 11.4142 13.3906C11.5133 13.4869 11.4991 13.5233 11.4991 13.5H12.6991C12.6991 13.0962 12.4962 12.7688 12.2508 12.5302C12.0071 12.2933 11.6848 12.1048 11.3337 11.9556L10.8645 13.06ZM10.4991 9V12.5078H11.6991V9H10.4991ZM9.02892 8.65278C9.57434 8.71704 10.0067 8.83264 10.2838 8.96105C10.4236 9.02581 10.4947 9.08052 10.5227 9.10895C10.5483 9.13502 10.4991 9.09711 10.4991 9H11.6991C11.6991 8.68518 11.5456 8.4377 11.3783 8.26757C11.2133 8.09979 11.0029 7.97168 10.7883 7.87225C10.3568 7.67229 9.78909 7.53404 9.16933 7.46102L9.02892 8.65278ZM8.49912 4V8.0569H9.69912V4H8.49912Z",
    fill: "black",
    mask: "url(#path-1-inside-1_173_3742)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.09912,
    cy: 4,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.0991,
    cy: 4,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09912 4H13.0991",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09912 12.5C5.59912 12.6667 6.89912 13 8.09912 13C9.29912 13 10.5991 12.6667 11.0991 12.5",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_3742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_173_3742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnemoclinograph);
export default __webpack_public_path__ + "static/media/anemoclinograph.029340c65af253f8e2e88a82cc973187.svg";
export { ForwardRef as ReactComponent };